export enum CmaLiteDeliveryRule {
  Z2                     = 'Z2',
  Z2_INTERNATIONALS_ONLY = 'Z2_INTERNATIONALS_ONLY',
}
